import React from 'react';
import classnames from 'classnames';
import breakpoints from './breakpoints.js';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { trackLink, trackPage } from '../lib/analytics-helper';
import getContent from 'pp-react-l10n';

const ORGANISM_NAME = 'vertical-nav';

const DEDICATED = 'dedicated';
const PORTABLE = 'portable';
const MOBILE = 'mobile';

export default class VerticalNav extends React.Component {
  constructor(props) {
    super(props);
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.brcLeftNavTopicClick = this.brcLeftNavTopicClick.bind(this);
    this.brcHomeClickFromCategory = this.brcHomeClickFromCategory.bind(this);
    const initialDeviceType = null;
    const getHeaderContent = getContent('staticContent');
    var {sections} = this.props;
    const refID = this.props.refID;
    const popArticleTopicSection = {
      text: getHeaderContent('brc.mostPopularArticles'),
    ref_id: 'most-popular-articles',
    url: '',
    description: '',
    categories: [ ]
    }
    if(this.props.isPopArticleEnabled){
      sections.push(popArticleTopicSection);
    }
    let section = _.find(sections, (section)=>section.ref_id===refID);
    if(!section) {
      section =  _.find(sections, (sect) => {
        if(sect.categories) {
          return _.find(sect.categories, (category)=>category.ref_id===refID)?true:false;
        }
        return false;
      });
    }
    const index = _.findIndex(sections, section);
    let obj ={};
    if(section && section.categories && section.categories.length>0) {
      obj = { userInteraction: true };
      obj['l1'] = [index];
    }
    this.state = {
      config: {
        id: '',
        accordion: true
      },
      menu: {
        text: 'Home',
        showLabel: true
      },
      menuOpen: true,
      userInteraction: false,
      l1: obj.l1 || [],
      l2: obj.l2 || [],
      deviceType: initialDeviceType,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  brcLeftNavTopicClick(refID) {
    trackLink({ id: 'brcLeftNavTopicClick', link: refID});
  }

  brcHomeClickFromCategory() {
    trackPage({ id: 'brcHomeClickFromCategory' });
  }

  handleResize() {
    if(window.innerWidth > breakpoints.large) {
      if(this.state.deviceType !== DEDICATED) {
        this.setState({
          deviceType: DEDICATED,
        });
      }
    }    else if(window.innerWidth > breakpoints.medium) {
      if(this.state.deviceType !== PORTABLE) {
        this.setState({
          deviceType: PORTABLE,
        });
      }
    }    else {
      if(this.state.deviceType !== MOBILE) {
        this.setState({
          deviceType: MOBILE,
        });
      }
    }
  }

  handleMenuClick() {
    this.setState({
      menuOpen: !this.state.menuOpen,
      userInteraction: true,
    });
  }

  render() {
    const getHeaderContent = getContent('staticContent');
    const country = (this.props.country).toLowerCase();
    const refID = this.props.refID;
    const sections = this.props.sections.filter(
      (section) => section.ref_id.toLowerCase() !== 'thank-you'
    );
    const classes = classnames('vertical-nav', {
      active: this.state.menuOpen,
    });
    /* Better performance if calculated once in componentDidMount? */
    let maxHeightOpened = 300 * (sections.length + 1);
    if (typeof window !== 'undefined') {
      if (maxHeightOpened > window.innerHeight) {
        maxHeightOpened = (window.innerHeight + 200); // composate top padding of the nav
      }
    }

    return (
    <div id = "leftnav-container" className="leftnavContainer">
      <nav
        className={classes}
        style={
        { maxHeight: (this.state.menuOpen || this.state.deviceType === DEDICATED ||
                      this.state.deviceType === PORTABLE) ? maxHeightOpened : 60 }
              }
        ref={(c) => {
          this.header = c;
        }}
      >
        {
          <button
            className={`${ORGANISM_NAME}__menu-btn pp-sans-small-medium ${this.state.deviceType === DEDICATED
              || this.state.deviceType === null || this.state.deviceType === PORTABLE ? 'hidden' : ''}`}
            onClick={this.handleMenuClick}
          >
            {'Menu'}
          </button>
        }
        { this.props.isHomeBtnEnabled ?
          <div tabIndex = "-1" className={`${ORGANISM_NAME}__home-btn`}>
            <a data-pa-click = {'brcHomeClickFromCategory'} href= {this.props.attachUrl.length>0 ? `/${country}/brc/?${this.props.attachUrl}` : `/${country}/brc/`} >{getHeaderContent('brc.leftNavHome')}</a>
          </div> : null
        }
        {sections && (
          <div className={`${ORGANISM_NAME}__menu`}>
            <ul className={`${ORGANISM_NAME}__sections`}>
              {sections.map((section, index) => {
                const categories = section.categories;
                // let l1Clicked = this.brcLeftNavTopicClick.bind(this, section.ref_id);
                const sectionAnchor = <a data-pa-click={`brcLeftNav|L1TopicClick|${section.ref_id}`}
                  href = {this.props.attachUrl.length>0 ? `/${country}/brc/topics/${section.ref_id}?${this.props.attachUrl}` : `/${country}/brc/topics/${section.ref_id}`}>{section.text}</a>;
                const isActive = this.state.l1.indexOf(index) > -1;
                return (
                  <li key={section.text + index} className={`${section.ref_id === refID ? 'highlight' : ''}`} >

                    {sectionAnchor}
                    {categories && isActive ? (
                      <ul className={`${ORGANISM_NAME}__categories ${isActive ? 'active' : 'hidden'}`}>
                        {categories.map((category, index2) => {
                          return (
                            <li key={category.text + index2}
                              className={`${category.ref_id === refID ? 'highlight' : ''}`}>
                              <a
                                data-pa-click ={`brcLeftNav|L2TopicClick|${category.ref_id}`}
                                href={this.props.attachUrl.length>0 ? `/${country}/brc/topics/${category.ref_id}?${this.props.attachUrl}` : `/${country}/brc/topics/${category.ref_id}`}
                              >
                                {category.text}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    ) :''}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </nav>
    </div>
    );
  }
}

VerticalNav.propTypes = {
  sections: PropTypes.array,
  refID: PropTypes.string,
  country: PropTypes.string,
  isHomeBtnEnabled: PropTypes.bool,
};
